/**
 * Configuration centralisée des 4 questionnaires Oria.
 * Source de vérité pour les id, routes, icônes et contraintes premium.
 *
 * @type {Array<{
 *   id: 'valeurs'|'interets'|'energies'|'intelligences',
 *   emoji: string,
 *   label: string,
 *   path: string,
 *   premium: boolean,
 *   premiumReason: ((pronoun: string) => string) | null,
 * }>}
 */
export const QUIZZES = [
  {
    id: 'valeurs',
    emoji: '💜',
    label: 'Valeurs',
    path: '/questionnaires/mes-valeurs',
    premium: false,
    premiumReason: null,
  },
  {
    id: 'interets',
    emoji: '🧭',
    label: 'Intérêts',
    path: '/questionnaires/mes-interets',
    premium: true,
    premiumReason: () => "découvrir ce qu'elle aime faire",
  },
  {
    id: 'energies',
    emoji: '⚡',
    label: 'Énergies',
    path: '/questionnaires/mes-energies',
    premium: true,
    premiumReason: (pronoun) => `découvrir ce qui ${pronoun} motive`,
  },
  {
    id: 'intelligences',
    emoji: '🧩',
    label: 'Intelligences',
    path: '/questionnaires/mes-intelligences',
    premium: true,
    premiumReason: () => 'découvrir en quoi elle excelle',
  },
];

/** Map id → quiz pour accès direct */
export const QUIZZES_BY_ID = Object.fromEntries(QUIZZES.map(q => [q.id, q]));
